import React, { useState } from "react";
import Nav from "../../components/nav/Nav";
import Footer from "../../components/footer/Footer";
import "./accountSettings.css";
import { ReactComponent as UserRounded } from "../../assets/User Rounded.svg";
import { ReactComponent as ChevronRight } from "../../assets/chevron-right.svg";
import ManagePersonalInfo from "./ManagePersonalInfo";
import { ReactComponent as Bell } from "../../assets/Bell.svg";
import NotificationPrefrence from "./NotificationPrefrence";
import { Link, useNavigate } from "react-router-dom";
import CustomButton from "../../components/CustomButton";
import { useDispatch } from "react-redux";
import base_url from "../../api/bootapi";
import axios from "axios";
import { logout } from "../../components/Reducers/userSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDisclosure } from "@mantine/hooks";
import { Modal } from "@mantine/core";

const AccountSettings = () => {
  const [selected, setSelected] = useState("personalInfo");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [opened, { open, close }] = useDisclosure(false);

  const clearLocalStorage = () => {
    // List all keys you want to remove
    const keysToRemove = [
      "travelerInformationData",
      "claimType", 
      "OriginallyBookedFlightsData", 
      "actualFlightDetailsData", 
      "completedStep",
    ];

    keysToRemove.forEach((key) => localStorage.removeItem(key));
  };

  const handle403error = (err) => {
    if (err) {
      if (err.response) {
        if (
          Number(err?.response?.status) === 403 ||
          Number(err?.response?.status) === 401
        ) {
          setTimeout(() => {
            console.log("Unauthorized or forbidden. Logging out.");
            dispatch(logout());
            // localStorage.clear();
            localStorage.setItem("from_403_status", "call_toast");
            navigate("/login");
            // toast.warn("Session Expired");
            toast.success("Logged Out Successfully");
          }, 1000);
        }
      }
    }
  };

  const handleLogOut = async () => {
    try {
      const token = localStorage.getItem("client_token");

      if (!token) {
        console.log("No token found, logging out anyway.");
      } else {
        await axios.get(`${base_url.api1}/users/logout`, {
          headers: {
            Authorization: `JWT ${token}`,
          },
        });
      }
      clearLocalStorage();
      dispatch(logout());
      toast.success("Logged Out Successfully");
      navigate("/login");
    } catch (error) {
      handle403error(error);
      console.error("Logout failed:", error);
      toast.error("Error: Logout failed!");
    }
  };
  return (
    <div className="account-setting-wrapper">
      <Modal
        opened={opened}
        onClose={close}
        centered
        radius={"lg"}
        size={"md"}
        withCloseButton={false}
      >
        <div
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "30px",
            padding: "30px",
          }}
        >
          {/* <CircleTickIcon /> */}
          <h5
            style={{ color: "#314064", fontSize: "24px", textAlign: "center" }}
          >
            Are you sure want to logout ?
          </h5>

          <div className="logout-btn-wrapper">
            <CustomButton
              style={{ width: "50%" }}
              btnText={"Cancel"}
              flex={1}
              onClick={close}
              type="secondary"
            />

            <CustomButton
              style={{ width: "50%" }}
              btnText={"Logout"}
              flex={1}
              onClick={handleLogOut}
              type="danger"
            />
          </div>
        </div>
      </Modal>
      <Nav />
      <div
        className="breadcrums-container account-breadcrums"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <ToastContainer />
        <ul className="breadcrums">
          <Link
            to="/dashboard"
            className="breadcrums-link"
            style={{ color: "#799DD2" }}
          >
            Dashboard
          </Link>
          <ChevronRight />
          <Link className="breadcrums-link" style={{ color: "#565A6D" }}>
            Account settings & preferences
          </Link>
        </ul>

        <CustomButton onClick={open} type="secondary" btnText="Log Out" />
      </div>
      <div className="account-wrrapper">
        <div className="account-container">
          <div className="account-buttons-container">
            <div>
              <button
                onClick={() => setSelected("personalInfo")}
                className={`account-button ${
                  selected === "personalInfo" ? "onclick-button-background" : ""
                }`}
              >
                <div
                  className={`account-button-logo-wrapper ${
                    selected === "personalInfo"
                      ? "onclick-button-background-logo"
                      : ""
                  }`}
                  style={{
                    backgroundColor:
                      selected === "personalInfo" ? "#FAFDFF" : "#eff3f9",
                  }}
                >
                  <UserRounded className={`account-button-logo `} />
                </div>
                Account settings
              </button>
              <button
                onClick={() => setSelected("Notification")}
                className={`account-button ${
                  selected === "Notification" ? "onclick-button-background" : ""
                }`}
                style={{ marginTop: "20px" }}
              >
                <div
                  className={`account-button-logo-wrapper ${
                    selected === "notification"
                      ? "onclick-button-background-logo"
                      : ""
                  }`}
                  style={{
                    backgroundColor:
                      selected === "Notification" ? "#FAFDFF" : "#eff3f9",
                  }}
                >
                  <Bell className="account-button-logo" />
                </div>
                Notifications
              </button>
            </div>
          </div>

          <div className="personal-info-container">
            {selected === "personalInfo" && <ManagePersonalInfo />}
            {selected === "Notification" && <NotificationPrefrence />}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AccountSettings;
